import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function InvestmentFilter() {
  const { t } = useLang();
  const c = t.filter;
  return (
    <section id="filtro" data-testid="filter-section" className="py-24 sm:py-32 bg-olive text-ivory">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-ivory/80 leading-relaxed font-serif italic">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-px bg-ivory/15">
          {c.items.map((it, i) => (
            <Reveal key={i} delay={i * 50} data-testid={`filter-item-${i}`} className="bg-olive p-6 flex flex-col gap-3 lg:min-h-[200px]">
              <div className="big-num text-5xl text-terracotta">{it.tag}</div>
              <div className="font-display text-xl leading-tight">{it.title}</div>
              <p className="text-ivory/70 text-sm leading-relaxed">{it.body}</p>
            </Reveal>
          ))}
        </div>

        {c.closing && (
          <Reveal>
            <p data-testid="filter-closing" className="mt-12 max-w-4xl text-base text-ivory/80 leading-relaxed font-serif italic">
              {c.closing}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
